import { render, staticRenderFns } from "./RecommendedClasses.vue?vue&type=template&id=75435638"
import script from "./RecommendedClasses.vue?vue&type=script&lang=js"
export * from "./RecommendedClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports